<template>
  <div class="chrtcol">
    <div class="chrtcol_cell chrtcol_label">
      <slot name="label"></slot>
    </div>
    <div class="chrtcol_cell chrtcol_value">
      <slot name="value">
        <div class="chrtcol_value_chart"></div>
      </slot>
    </div>
    <div class="chrtcol_cell chrtcol_after">
      <slot name="after"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChartColumn',
  data() {
    return {}
  },
}
</script>

<style lang="scss" scoped>
.chrtcol {
  --clr-back-chart: var(--clr-black-2);
  --clr-chart: currentColor;
  --chart-value: 100%;

  flex: 1;
  display: flex;
  position: relative;
  flex-shrink: 0;
  &_table {
    display: table-row;
    --chart-height: 1.25rem;
    --radius-chart: 4px;
    --cell-height: 1.875rem;
    .chrtcol {
      &_cell {
        display: table-cell;
        height: var(--cell-height);
        vertical-align: middle;
      }
      &_value {
        position: relative;
        width: 100%;
        &_chart {
          position: relative;
          background: var(--clr-back-chart);
          border-radius: var(--radius);
          height: var(--chart-height);
          width: 100%;
          transition: 0.22s;
          &::before {
            content: '';
            left: 0;
            top: 0;
            position: absolute;
            background: var(--clr-chart);
            border-radius: var(--radius-chart);
            height: var(--chart-height);
            width: var(--chart-value);
            transition: 0.22s;
          }
        }
      }
    }
  }
  &_column {
    display: flex;
    flex-wrap: wrap;
    --chart-height: 6rem;
    --radius-chart: 8px;

    .chrtcol_value {
      order: 2;
    }
    .chrtcol_label {
      // order: 3;
      order: 2;
      // flex: 1;
      // width: 100%;
    }
    .chrtcol_after {
      // order: 1;
      order: 3;
      // flex: 1;
    }
    .chrtcol {
      &_cell {
        display: flex;
        // align-items: center;
        // justify-content: center;
        height: var(--cell-height);
        width: 100%;
      }
      &_value {
        position: relative;
        display: flex;
        // align-items: flex-end;
        width: 100%;
        &_chart {
          flex: 1;
          position: relative;
          background: var(--clr-back-chart);
          border-radius: var(--radius-chart);
          height: var(--chart-height);
          // width: 100%;
          transition: 0.22s;
          &::before {
            content: '';
            left: 0;
            bottom: 0;
            position: absolute;
            background: var(--clr-chart);
            border-radius: var(--radius-chart);
            height: var(--chart-value);
            width: 100%;
            transition: 0.22s;
          }
        }
      }
    }
  }
}
</style>
